import React from "react";
import moment from "moment";
import { Col, Collapse, Row, Tag, Button, Spin } from "antd";
import { Link } from "react-router-dom";
import CheckOutlined from "@ant-design/icons/es/icons/CheckOutlined";
import CloseOutlined from "@ant-design/icons/es/icons/CloseOutlined";
import StarOutlined from "@ant-design/icons/es/icons/StarOutlined";
import StarFilled from "@ant-design/icons/es/icons/StarFilled";
import { useDispatch } from "react-redux";
import Label from "../Label/Label";
import Localize from "../../libs/localization";
import { get } from "../../libs/helpers/ioc";
import { toUpper } from "lodash";
import { translateRegistryOnView } from "../../libs/utils";
import { deleteAssociatedIdTagAction } from "../../actions/tag.actions";

const { Panel } = Collapse;

const Pitch = (props) => {
  const {
    item,
    onMoreBrandClick,
    isPitchPage = false,
    tagMode = false,
    setSelectedPitch = () => {},
    loadingTag = false,
    associatedTagsIds = [],
    selectedPitches = [],
    onTagRemove = () => {},
  } = props;
  const permissions = get("scopes");
  const dispatch = useDispatch();

  const isSelected = selectedPitches.includes(item._id);

  const handleToggleSelection = (e) => {
    e.stopPropagation();
    const currentSelections = selectedPitches || [];
    if (isSelected) {
      setSelectedPitch(currentSelections.filter((id) => id !== item._id));
    } else {
      setSelectedPitch([...currentSelections, item._id]);
    }
  };

  const renderTag = (item) => {
    let renderedTags = [];
    associatedTagsIds &&
      associatedTagsIds.map((association) => {
        const founded = association._id === item._id;
        if (founded) {
          renderedTags = association.tags.map((tag) => (
            <Tag
              key={tag.tagId}
              color={`#${tag.color}`}
              className="searchPage__item-tag ml-2"
              closable
              onClose={(e) => {
                e.stopPropagation();
                dispatch(
                  deleteAssociatedIdTagAction(
                    {
                      tagId: tag.tagId,
                      associatedId: association._id,
                    },
                    onTagRemove,
                  ),
                );
              }}
            >
              {tag.name}
            </Tag>
          ));
        }
      });
    return renderedTags;
  };

  const renderStar = () => {
    const Component = isSelected ? StarFilled : StarOutlined;
    return <Component style={{ fontSize: 20 }} />;
  };

  return (
    <Collapse ghost expandIconPosition="right">
      <Panel
        header={
          isPitchPage ? (
            <>
              <Row align="middle">
                {tagMode && (
                  <Button
                    type="text"
                    shape="circle"
                    size="small"
                    className="mr-2"
                    onClick={handleToggleSelection}
                  >
                    {renderStar()}
                  </Button>
                )}
                {moment(item.start_date).format("DD/MM/YYYY")} {` | `}{" "}
                {isPitchPage && item.company && (
                  <Link to={`/companies/${item.company?.id}`}>
                    <p className="ml-1 my-0 p-0">
                      {toUpper(item.company?.name)}
                    </p>
                  </Link>
                )}
                {loadingTag ? (
                  <Spin size="small" className="ml-4" />
                ) : (
                  renderTag(item)
                )}
              </Row>
              <Row>
                <b className="customCard__pitchList-title-no-margin">
                  {item.title}
                </b>
                {item.category?.map &&
                  item.category.map((c) => (
                    <Tag key={c._id} className="ml-3 mr.0">
                      {translateRegistryOnView(c._id, "Category")
                        ? translateRegistryOnView(c._id, "Category")
                        : c.key}
                    </Tag>
                  ))}
              </Row>
            </>
          ) : (
            <Row align="middle">
              {tagMode && (
                <Button
                  type="text"
                  shape="circle"
                  size="small"
                  className="mr-2"
                  onClick={handleToggleSelection}
                >
                  {renderStar()}
                </Button>
              )}
              {moment(item.start_date).format("DD/MM/YYYY")} {` | `}{" "}
              <b className="customCard__pitchList-title mr-2">{item.title}</b>
              {item.category?.map &&
                item.category.map((c) => (
                  <Tag key={c._id}>
                    {translateRegistryOnView(c._id, "Category")
                      ? translateRegistryOnView(c._id, "Category")
                      : c.key}
                  </Tag>
                ))}
              {loadingTag ? (
                <Spin size="small" className="ml-4" />
              ) : (
                renderTag(item)
              )}
            </Row>
          )
        }
        key="1"
      >
        {onMoreBrandClick && item.brands.length > 0 && (
          <Col span={24} className="mb-3 p-0 align-content-center">
            <Row align="middle">
              <Label
                value={Localize("PAGES.COMPANIES.DETAIL.SECTIONS.MODAL.BRANDS")}
                className="my-0 mr-1 p-0"
              />
              <span className="mx-1">:</span>
              {item.brands.slice(0, 5).map((b) => (
                <Link to={`/companies/${item.company?.id}?brand=${b.id}`}>
                  <Tag style={{ cursor: "pointer" }} key={b.id}>
                    {toUpper(b.name)}
                  </Tag>
                </Link>
              ))}
              {item.brands.length > 5 && (
                <Tag
                  className="pointer"
                  onClick={() =>
                    onMoreBrandClick(
                      <Label
                        value={Localize(
                          "PAGES.COMPANIES.DETAIL.SECTIONS.MODAL.BRANDS",
                        )}
                      />,
                      <ul>
                        {item.brands.map((b) => (
                          <a
                            href={`/companies/${item.company?.id}?brand=${b.id}`}
                          >
                            <li>{toUpper(b.name)}</li>
                          </a>
                        ))}
                      </ul>,
                    )
                  }
                >
                  + {item.brands.length - 5}{" "}
                </Tag>
              )}
            </Row>
          </Col>
        )}
        <div>
          {item.winnerCompany && (
            <p>
              <b>{Localize("PAGES.COMPANIES.DETAIL.SECTIONS.MODAL.WINNER")}</b>
              <span className="mx-1">:</span>
              <Link
                style={{
                  pointerEvents: Object.keys(permissions || {})?.includes(
                    "company",
                  )
                    ? ""
                    : "none",
                }}
                to={`/companies/${item.winnerCompany.id}`}
              >
                {toUpper(item.winnerCompany.name)}
              </Link>
            </p>
          )}
          {item.formerWinner && (
            <p>
              <b>
                {Localize(
                  "PAGES.COMPANIES.DETAIL.SECTIONS.MODAL.FORMER_WINNER",
                )}
              </b>
              <span className="mx-1">:</span>
              <Link
                style={{
                  pointerEvents: Object.keys(permissions || {})?.includes(
                    "company",
                  )
                    ? ""
                    : "none",
                }}
                to={`/companies/${item.formerWinner.id}`}
              >
                {toUpper(item.formerWinner.name)}
              </Link>
            </p>
          )}
          {item.comment && <p>{item.comment}</p>}
          <p>
            <b>
              {Localize("PAGES.COMPANIES.DETAIL.SECTIONS.MODAL.COMPETITION")}
            </b>
            <span className="mx-1">:</span>
            {item.competition ? (
              <CheckOutlined
                style={{
                  color: "#1b6c6e",
                  fontSize: "1rem",
                  marginLeft: "10px",
                }}
              />
            ) : (
              <CloseOutlined
                style={{
                  color: "red",
                  fontSize: "1rem",
                  marginLeft: "10px",
                }}
              />
            )}
          </p>
        </div>
      </Panel>
    </Collapse>
  );
};

export default Pitch;
